// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.balance-container[data-v-a860dfcc]{\n  margin: 40px 57px 50px 32px;\n}\n", ""]);
// Exports
module.exports = exports;
